import { animate, query, stagger, style, transition, trigger, } from "@angular/animations";
import { ChangeDetectorRef, Component, OnInit, OnDestroy, ChangeDetectionStrategy, } from "@angular/core";
import { Router } from "@angular/router";
import { CoreLanguageService } from "../../services/language.service";
import { Location } from "@angular/common";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { environment } from "../../../../environments/environment";
import { CoreCOMService } from "../../services/com.service";
import { CoreLogService } from "../../services/log.service";
import { WebShopService } from "../../services/webShop.service";
import { Observable, Subscription } from "rxjs";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { ServiceCallService } from "../serviceCall/serviceCall.service";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { SecureCheckDialogComponent, WarningdialogComponent, BasketPayOptionsDialogComponent, BasketPayConfirmDialogComponent, BasketPayOptionsDialogModaldata, } from "../../modalDialogs";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { InHouseOrderService } from "../../services/inHouseOrder.service";
import { IUiData, req_ChangeBasket, BasketChangeType, } from "../../services/IInHouseOrderService";
import Utils from "../../shared/utils";
import { InHauseServiceSelectorService } from "./inHauseServiceSelector.service";
import { InHouseOrder, ServiceCallDataModel } from "../../shared/models";
import { LocalKeys, StorageHive } from "../../services/valueStorage.service";
import { ExternalLinksSettingsService } from "../../services/ExternalLinksSettings.service";
import { SnackBarService } from "../../services/snackBar.service";

@Component({
  selector: "inHauseServiceSelector",
  templateUrl: "./inHauseServiceSelector.component.html",
  styleUrls: ["./inHauseServiceSelector.component.scss"],
  providers: [
    InHauseServiceSelectorService,
    ServiceCallService,
    OverlaySpinnerService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger("serviceButtonEntering", [
      transition("false => true", [
        query(".animate", [
          style({ transform: "scale(0)" }),
          stagger(100, [
            animate("400ms ease-out", style({ transform: "scale(1.1)" })),
            animate("100ms ease-in-out", style({ transform: "scale(1)" })),
          ]),
        ]),
      ]),
    ]),
  ],
})
export class InHauseServiceSelectorComponent implements OnInit, OnDestroy {
  public isLoaded: boolean = false;
  public useBrowserHistory: boolean = true;
  public isSmallView: boolean = false;

  /** InHouse hat eine Zahlung und darf bezahlt werden (wen true, wird der PaymentButton angezeigt) */
  public hasPayment: boolean = false;
  private _hasBannerBeenClosed: boolean = false;

  private _serviceCallsSubscriber: Subscription;
  private _inHouseUiDataChangedSubscriber: Subscription;
  private _WebshopSettingsInHouseOrderSubscriber: Subscription;
  private _langSubscriber: Subscription;
  public readyForPickUpCount$: Observable<number>;

  constructor(
    private _router: Router,
    private _coreLanguageService: CoreLanguageService,
    private _internationalisationService: InternationalisationService,
    private _location: Location,
    private _serviceCallService: ServiceCallService,
    private _coreComService: CoreCOMService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _coreLogService: CoreLogService,
    private _externalLinksSettingsService: ExternalLinksSettingsService,
    private _overlaySpinnerService: OverlaySpinnerService,
    private _bottomSheetHelperService: BottomSheetHelperService,
    private _webShopService: WebShopService,
    private _inHouseOrderService: InHouseOrderService,
    private _inHauseServiceSelectorService: InHauseServiceSelectorService,
    private _snackBarService: SnackBarService,
    mainnavService: MainnavService
  ) {
    this.isSmallView = mainnavService.viewType === ViewType.Small;
  }

  ngOnInit() {
    const me = this;
    me._inHouseOrderService
      .GetStatus()
      .then((status) => {
        if (!status.has_pos_connection) {
          me.OpenWarningNoConnectionDialog();
          me.leaveTable(); // automatisch Tisch verlassen und zum HomeScreen
          return; // break here
        }

        me.readyForPickUpCount$ = me._inHauseServiceSelectorService.readyForPickUpCount$;

        me._inHouseUiDataChangedSubscriber = me._inHouseOrderService.ObserveUiDataChanged.subscribe(
          async (newUiData) => {
            await me.bindUiData(newUiData);
            me.PushChanges();
          }
        );

        me._serviceCallsSubscriber = me._inHauseServiceSelectorService.ObserveServiceCallsChanges.subscribe(
          async () => {
            if (await me.bindServiceCalls()) me.PushChanges();
          }
        );

        me._WebshopSettingsInHouseOrderSubscriber = me._inHauseServiceSelectorService.ObserveWebshopSettingsInHouseOrderChanges.subscribe(
          async () => {
            if (await me.bindWebshopSettingsInHouseOrder()) me.PushChanges();
          }
        );

        me._langSubscriber = me._internationalisationService.localeChanged.subscribe(() => {
          me.PushChanges();
        });

        me._coreComService.environment.valueStorage
          .get(StorageHive.Local, LocalKeys.bannerBeenClosed)
          .then((value) => {
            value ? (me._hasBannerBeenClosed = true) : false;
          });

        Promise.all([
          me.bindServiceCalls(),
          me.bindWebshopSettingsInHouseOrder(),
          me.bindUiData(me._inHouseOrderService.UiData),
          me.bindHasPayment(),
        ])
          .then(async (results) => {
            if (!results[0])
              me._coreLogService.error(
                "InHauseServiceSelectorComponent.ngOnInit",
                "bindServiceCalls fails"
              );
            if (!results[1])
              me._coreLogService.error(
                "InHauseServiceSelectorComponent.ngOnInit",
                "bindWebshopSettingsInHouseOrder fails"
              );
            // bindUiData = results[2] is void
            // bindHasPayment = results[3] is void
            me.isLoaded = true;
            me.PushChanges();
          })
          .catch((error) => {
            me._coreLogService.error(
              "InHauseServiceSelectorComponent.ngOnInit",
              "Promise.all(catch)",
              error
            );
            me.isLoaded = true;
            me.PushChanges(); // eventuell um nichts zu zeichenen?
          });
      })
      .catch((error) => {
        me._coreLogService.error(
          "InHauseServiceSelectorComponent.ngOnInit",
          "inHouseOrderService.GetStatus(catch)",
          error
        );
        me.leaveTable(); // automatisch Tisch verlassen und zum HomeScreen
      });
    me._serviceCallsSubscriber = me._serviceCallService.ObserveServiceCallsChanges.subscribe(async () => {
      try {
        if (await me.bindServiceCalls()) me.PushChanges();
      } catch (error) {
        me._coreLogService.error(
          "ServiceCallComponent.ngOnInit",
          "ObserveServiceCallsChanges.bindServiceCalls.catch",
          error
        );
      }
    });

    me.bindServiceCalls()
      .then(() => {
        me.isLoaded = true;
        me.PushChanges();
      })
      .catch((error) => {
        me._coreLogService.error(
          "ServiceCallComponent.ngOnInit",
          "bindServiceCalls.catch",
          error
        );
        me.PushChanges();
      });
  }

  ngOnDestroy() {
    const me = this;
    if (me._langSubscriber) me._langSubscriber.unsubscribe();
    if (me._WebshopSettingsInHouseOrderSubscriber)
      me._WebshopSettingsInHouseOrderSubscriber.unsubscribe();
    if (me._serviceCallsSubscriber) me._serviceCallsSubscriber.unsubscribe();
    if (me._inHouseUiDataChangedSubscriber)
      me._inHouseUiDataChangedSubscriber.unsubscribe();
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (error) {
      this._coreLogService.error(
        "InHauseServiceSelectorComponent.PushChanges",
        "_changeDetectorRef.detectChanges (catch)",
        error
      );
    }
  }

  /** representiert aktuelle ServiceCalls */
  public ServiceCalls: ServiceCallDataModel[] = [];
  /** ermittelt die aktuellen ServiceCalls */
  private async bindServiceCalls(): Promise<boolean> {
    const me = this;
    try {
      me.ServiceCalls =
        await me._inHauseServiceSelectorService.GetServiceCalls();
      return true;
    } catch (error) {
      me._coreLogService.error(
        "InHauseServiceSelectorComponent.bindServiceCalls",
        "catch",
        error
      );
      return false;
    }
  }

  public get hasServiceCall(): boolean {
    return this.ServiceCalls.length > 0;
  }

  /** bindet hasPayment richtig um den PaymentButton anzuzeigen */
  private async bindHasPayment(): Promise<boolean> {
    const me = this;
    try {
      me.hasPayment = await me._inHouseOrderService.HasPaymentOnServer();
      // PushChanges wird in ngOnInit aufgerufen
      return true;
    } catch (error) {
      me._coreLogService.error(
        "InHauseServiceSelectorComponent.bindHasPayment",
        "catch",
        error
      );
      return false;
    }
  }

  /** representiert aktuelle InhOuseOrder Einstellungen  */
  public WebshopSettingsInHouseOrder: InHouseOrder = null;
  /** ermittelt die aktuellen InhOuseOrder Einstellungen */
  private async bindWebshopSettingsInHouseOrder(): Promise<boolean> {
    const me = this;
    try {
      me.WebshopSettingsInHouseOrder =
        await me._inHauseServiceSelectorService.GetWebshopSettingsInHouseOrder();
      await me.recalcPaymentButtonStatus(); // abhängig von WebhopSettings
      return true;
    } catch (error) {
      me._coreLogService.error(
        "InHauseServiceSelectorComponent.bindServiceCalls",
        "catch",
        error
      );
      return false;
    }
  }

  public get hasImagePhoto(): boolean {
    const me = this;
    if (
      me.WebshopSettingsInHouseOrder &&
      me.WebshopSettingsInHouseOrder.landing_page
    )
      return (
        me.WebshopSettingsInHouseOrder.landing_page.last_image_update_at_ymd > 0
      );
    else return false;
  }

  public get imagePhoto(): string {
    const me = this;
    if (
      me.WebshopSettingsInHouseOrder &&
      me.WebshopSettingsInHouseOrder.landing_page
    )
      return me.WebshopSettingsInHouseOrder.landing_page.image_photo;
    else return "";
  }

  public get useImageLabel(): boolean {
    const me = this;
    if (
      me.WebshopSettingsInHouseOrder &&
      me.WebshopSettingsInHouseOrder.landing_page
    )
      return me.WebshopSettingsInHouseOrder.landing_page.use_image_label;
    else return false;
  }

  public get imageLabel(): string {
    const me = this;
    if (
      me.WebshopSettingsInHouseOrder &&
      me.WebshopSettingsInHouseOrder.landing_page
    )
      return me.WebshopSettingsInHouseOrder.landing_page.image_label;
    else return "";
  }

  public get orderButtonTitle(): string {
    const me = this;
    if (
      me.WebshopSettingsInHouseOrder &&
      me.WebshopSettingsInHouseOrder.landing_page
    )
      return me.WebshopSettingsInHouseOrder.landing_page.order_label;
    else return "";
  }

  public get orderButtonDescription(): string {
    const me = this;
    if (
      me.WebshopSettingsInHouseOrder &&
      me.WebshopSettingsInHouseOrder.landing_page
    )
      return me.WebshopSettingsInHouseOrder.landing_page.order_subtext;
    else return "";
  }

  public get payButtonTitle(): string {
    const me = this;
    if (
      me.WebshopSettingsInHouseOrder &&
      me.WebshopSettingsInHouseOrder.landing_page
    )
      return me.WebshopSettingsInHouseOrder.landing_page.pay_label;
    else return "";
  }

  public get payButtonDescription(): string {
    const me = this;
    if (
      me.WebshopSettingsInHouseOrder &&
      me.WebshopSettingsInHouseOrder.landing_page
    )
      return me.WebshopSettingsInHouseOrder.landing_page.pay_subtext;
    else return "";
  }

  public get serviceCallButtonTitle(): string {
    const me = this;
    if (
      me.WebshopSettingsInHouseOrder &&
      me.WebshopSettingsInHouseOrder.landing_page
    )
      return me.WebshopSettingsInHouseOrder.landing_page.service_call_label;
    else return "";
  }

  public get serviceCallButtonDescription(): string {
    const me = this;
    if (
      me.WebshopSettingsInHouseOrder &&
      me.WebshopSettingsInHouseOrder.landing_page
    )
      return me.WebshopSettingsInHouseOrder.landing_page.service_call_subtext;
    else return "";
  }

  private uiData: IUiData;
  private async bindUiData(uiData: IUiData): Promise<void> {
    const me = this;
    me.uiData = uiData;
    await me.recalcOrderButtonStatus();
    await me.recalcPaymentButtonStatus();
  }

  public get mandatoryPayment() {
    const me = this;
    return me._inHouseOrderService.TableData.mandatory_Payment;
  }

  private _isOrderPossible: boolean = false;
  public get isOrderButtonActive(): boolean {
    return this._isOrderPossible;
  }

  public async recalcOrderButtonStatus(): Promise<void> {
    const me = this;
    me._isOrderPossible =
      !(await me._inHauseServiceSelectorService.PaymentInhouseWithoutOrder());
  }

  private _isPaymentPossible: boolean = false;
  public get isPaymentButtonActive(): boolean {
    return this._isPaymentPossible;
  }

  public async recalcPaymentButtonStatus(): Promise<void> {
    const me = this;
    me._isPaymentPossible =
      me.hasOpenItems &&
      (await me._inHauseServiceSelectorService.OrderInHouseWithoutPayment());
  }

  public get tableNumberText(): string {
    const me = this;
    return me._coreLanguageService
      .value("phInHouseService_Table")
      .replace("{table_no}", me.uiData ? me.uiData.table_no : "");
  }

  private get guestText(): string {
    const me = this;
    return me._coreLanguageService
      .value("phInHouseService_Guest")
      .replace(
        "{seat_no}",
        me.uiData && me.uiData.place_no > 0 ? me.uiData.place_no.toString() : ""
      );
  }

  public get userText(): string {
    const me = this;
    let userName = me.uiData ? me.uiData.user_nickname : "";
    if (Utils.IsNullOrEmpty(userName)) userName = me.guestText;
    return userName;
  }

  private get hasOpenItems(): boolean {
    const me = this;
    return me.uiData ? me.uiData.open_amount > 0 : false;
  }

  public get openItemsText(): string {
    const me = this;
    return me.uiData ? me.uiData.open_amount.toString() : "";
  }

  public get openPriceText(): string {
    const me = this;
    return me.uiData
      ? me._webShopService.formatCurrency(me.uiData.open_price)
      : "";
  }

  /** Display App banner only if Safari Mobile or Desktop browser is used,App exist and banner has not been closed
   * !Mark On iPad "Request desktop website" is the default Safari setting*/
  public get showIOSAppBanner(): boolean {
    const me = this;
    const isBrowserMobileSafari =
      this._coreComService.environment.client.isBrowserMobileSafari;
    const isBrowseSafari =
      this._coreComService.environment.client.isBrowserSafari;
    const appExist = environment.storeURL.AppleStore;
    return (
      (isBrowserMobileSafari || isBrowseSafari) &&
      appExist &&
      !me._hasBannerBeenClosed
    );
  }

  /** remove banner */
  public removeBanner(remove: boolean) {
    const me = this;
    me._hasBannerBeenClosed = remove;
    me._coreComService.environment.valueStorage.set(
      StorageHive.Local,
      LocalKeys.bannerBeenClosed,
      remove
    );
  }

  /** open App if installed,otherwise redirect to app store.*/
  public openApp() {
    const me = this;
    const qrCode = me._webShopService.qrCode;
    const target = `${environment.IntentScheme}://type=QRcodescanner&QRcode=${qrCode}`;
    try {
      window.open(target, "_self");
      setTimeout(() => {
        window.location.replace(environment.storeURL.AppleStore);
      }, 2000);
    } catch (e) {
      this._coreLogService.error(
        "InHauseServiceSelectorComponent.onExternIntent",
        "window.open, open application",
        e
      );
    }
  }

  public navigateToPayment() {
    const me = this;
    if (me.isPaymentButtonActive) {
      if (me._webShopService.getShippingCartItems().length > 0) {
        //Dialog zur warnung das noch artikel im basket sind
        const dialog = me._bottomSheetHelperService.open(
          SecureCheckDialogComponent,
          {
            data: {
              title: "phInHouse_ItemsInBasket_Title",
              description: "phInHouse_ItemsInBasket_Description",
              buttonTextAccept: "phInHouse_Accept_Btn",
              buttonTextDeny: "phInHouse_Cancel_Btn",
              icon: "shop-icons.svg#ya-hypersoft-achtung",
            },
            panelClass: "mat-bottom-sheet-container-medium",
          }
        );
        dialog.afterDismissed().subscribe((accepted) => {
          if (accepted) {
            // wenn tisch ausbezahlt wird, werden die BasketItems gelöscht
            // clean up basket remote and local
            const request = new req_ChangeBasket();
            request.change_type = BasketChangeType.Full;
            request.items = [];
            request.return_items = false;
            me._inHouseOrderService.ChangeBasket(request);
            me._webShopService.clearItems();
            me._router.navigate(["/inHausePayment"]);
          } // else keep in place
        });
      } else {
        if (me._webShopService.isPayAtWaiterAvailable) {
          const bottomSheetRef = me._bottomSheetHelperService.open(
            BasketPayOptionsDialogComponent,
            {
              panelClass: "mat-bottom-sheet-container-medium",
            }
          );
          bottomSheetRef.afterDismissed().subscribe((result: boolean) => {
            if (result) {
              me._inHouseOrderService.GetTable(null).then((table) => {
                me._overlaySpinnerService.HideLayoutSpinner();
                const dialogData: BasketPayOptionsDialogModaldata = {
                  posTableNumber: table.posTable.tableNumber,
                  groupName: null,
                  tableNumber: me.uiData ? me.uiData.table_no : "",
                }
                me._bottomSheetHelperService.open(
                  BasketPayConfirmDialogComponent,
                  {
                    data: dialogData,
                    panelClass: "mat-bottom-sheet-container--full-height",
                  }
                );
              }).catch((error) => {
                me._overlaySpinnerService.HideLayoutSpinner();
                me._snackBarService.ShowErrorMessageFailed(47);
                me._coreLogService.error(
                  "InHauseServiceSelectorComponent.navigateToPayment",
                  "_inHouseOrderService.GetTable catch",
                  error
                );
              });
            }
            me._overlaySpinnerService.HideLayoutSpinner();
          });
        } else {
          me._router.navigate(["/inHausePayment"]);
        }
      }
    } else {
      me._bottomSheetHelperService.open(SecureCheckDialogComponent, {
        data: {
          title: "phInHouseService_NoOrderYet_Title",
          description: "phInHouseService_NoOrderYet_Description",
          buttonTextAccept: "phGlobal_Return",
          icon: "shop-icons.svg#ya-hypersoft-achtung",
        },
        panelClass: "mat-bottom-sheet-container-medium",
      });
    }
  }

  /** Navigate to Menugroup */
  public async navigateToMenuGroup() {
    const me = this;
    me._router.navigate(["/menugroup"]);
  }

  public navigateToTableOverview() {
    const me = this;
    if (me.hasOpenItems) {
      me._router.navigate(["/inHouseTableOverview"]);
    } else {
      me._bottomSheetHelperService.open(SecureCheckDialogComponent, {
        data: {
          title: "phInHouse_Table_Overview_Empty_Title",
          description: "phInHouse_Table_Overview_Empty_Desc",
          buttonTextAccept: "phGlobal_Return",
          icon: "shop-icons.svg#ya-hypersoft-tisch-voll.svg",
        },
        panelClass: "mat-bottom-sheet-container-medium",
      });
    }
  }

  /** Warning dialog: No connection to the restaurant */
  private OpenWarningNoConnectionDialog() {
    const me = this;
    me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: "phInHouse_NoConnection_Title",
        content: "phInHouse_NoConnection_Description",
        btnLabel: "phInHouse_Continue_Btn",
      },
      panelClass: "mat-bottom-sheet-container-medium",
    });
  }

  /** Navigate to Service Call */
  public navigateToServiceCall() {
    const me = this;
    me._router.navigate(["/servicecall"]);
  }

  public closeInHouseOrderingAsync() {
    const me = this;
    /**
     * User hat alles bezahlt -> Tisch verlassen
     *
     * User hat noch bestellungen, offene Zahlungen/Artikel -> Dialog
     */
    if (
      !me.hasOpenItems &&
      me._webShopService.getShippingCartItems().length == 0
    ) {
      me.leaveTable();
    } else {
      // todo auslagern, wird auch in webshop service verwendet
      const dialog = me._bottomSheetHelperService.open(
        SecureCheckDialogComponent,
        {
          data: {
            title: "phInHauseService_Leave_Table_Dialog_Title",
            description: "phInHauseService_Leave_Table_Content",
            buttonTextAccept: "phGlobal_Return",
            buttonTextDeny: "phInHauseService_Leave_Table_Dialog_Button",
            icon: "shop-icons.svg#ya-hypersoft-achtung",
          },
          panelClass: "mat-bottom-sheet-container-medium",
        }
      );
      dialog.afterDismissed().subscribe((accepted) => {
        //leaveTable only if it is false, click outside of Dialog === undefined
        if (accepted === false) {
          me.leaveTable();
        }
      });
    }
  }

  /** verläst tisch und beendet die offene verbindung */
  private async leaveTable(): Promise<void> {
    const me = this;
    me._inHouseOrderService.leaveTable(false);
  }

  /**If small view,navigate back by swiping from left to right.*/
  public swiperNavigateBack() {
    const me = this;
    if (me.isSmallView == true) {
      me.navigateBack();
    }
  }
  /** Navigate back*/
  public navigateBack() {
    const me = this;
    if (me.useBrowserHistory) {
      me._location.back();
    } else {
      me._router.navigate(["/menuservice"], { replaceUrl: true });
    }
  }
}